import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { UserGuideTopic } from 'src/models/user-guide-topic';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class UserGuideService {

  constructor(private http: HttpClient) { }

  list(): Observable<Array<UserGuideTopic>> {
    return this.http.get(`${environment.apiUrl}/user_guide/`) as Observable<UserGuideTopic[]>;
  }
}
